import styled from "@emotion/styled";
import { Stack } from "react-bootstrap";
import { IStyledComponentProps } from "../../../../theme/theme.types";

const ContactsListItem = styled(Stack)<IStyledComponentProps>`
  &.contact-list-item {
    margin: 0 16px;
    padding: 8px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grays.tertiary};

    .label-cell {
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      min-width: 154px;
      
      text-underline-offset: 6px;
      text-decoration: underline dotted ${({ theme }) =>
        theme.colors.brand.primary};
      

      @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
        text-underline-offset: 4px;
      }

      @media (min-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
        &:hover {
          cursor: pointer;
        }
    }

    &:last-child {
      border: 0 none;
    }

    @media (max-width: ${(props) =>
      props.theme.utils.getThemeBreakpoint("tablet")}) {
      margin: 0;
      min-height: 65px;
    }
  }

  &.last-contact-list-item {
    margin: 0 16px;
    padding: 8px 0;

    .label-cell {
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      min-width: 154px;
    }
  }

  .coordinator-email {
    text-decoration: none;
  }

  .fa-envelope {
    margin-left: 3px;
    color: #0079c1;
  }
`;

export default { ContactsListItem };
